// components/modals/orders/DispatchListModal.jsx
import React from "react";
import { Modal, Table, Button, Spinner } from "react-bootstrap";
import CustomPagination from "../../comman/CustomPagination";
import CloseBtn from "../CloseBtn";
import { DEFAULT_PAGE_OPTIONS } from "../../../utils/constants";
import SimpleTable from "../../comman/custom-table/SimpleTable";
import "./../index.css";

const fmtDate = (d) =>
  d
    ? new Date(d).toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
    : "-";

const DispatchListModal = ({
  show,
  onHide,
  order,
  loading,
  list,
  page,
  totalPages,
  total,
  pageSize,
  onPageChange,
}) => {
  // console.log("hds",list)
  // debugger;

  const columns = [
    { header: "#", cell: (_v, _r, i) => i + 1, sortable: false },
    { header: "Client Name", accessor: "client_name", sortType: "text" },
    { header: "Number", accessor: "number" },
    {
      header: "Address",
      accessor: "address",
      className: "small",
      minWidth: 220,
    },
    { header: "Delay Reason", accessor: "delay_reason" },
    { header: "Status", accessor: "status" },
    { header: "Tracking No", accessor: "tracking_no" },
    { header: "Courier", accessor: "courier" },
    { header: "Courier Mode", accessor: "courier_mode" },
    {
      header: "Dispatch Date",
      accessor: "dispatch_date",
      sortType: "date",
      cell: (v) =>
        v
          ? new Date(v)
              .toLocaleString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                hour12: true,
              })
              .replace(",", "")
          : "—",
    },
    {
      header: "Dispatch Remark",
      accessor: "dispatch_remark",
      className: "small",
    },
    { header: "Dispatch TAT", accessor: "dispatch_tat" },
    // { header: "Actions", isActions: true, sortable: false }, // Edit/Delete
  ];
  return (
    <Modal
      show={show}
      onHide={onHide}
      size={list?.length > 0 ? "xl" : "md"}
      centered
    >
      <CloseBtn onClick={onHide} color="#bf352b" />

      <Modal.Header className="">
        <Modal.Title>
          Dispatches — Order {order?.order_no ?? order?.id}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="overflow-hidden">
        {list?.length > 0 ? (
          <>
            <div className="small text-muted mb-2">
              Showing {list?.length || 0} of {total || 0} records
            </div>
            <div className="modal-table-body-cover">
              <div className="h-100">
                <SimpleTable
                  data={list}
                  columns={columns}
                  keyField="id"
                  size="sm"
                  responsive
                  loading={loading}
                  emptyMessage="no records found"
                  // onEdit={(row) => console.log("Edit", row)}
                  // onDelete={(row) => console.log("Delete", row)}
                />
                {/* <CustomPagination
                  currentPage={page}
                  totalPages={totalPages}
                  total={total}
                  pageSize={pageSize}
                  setPageSize={() => {}}
                  className={"sticky-bottom"}
                  setCurrentPage={onPageChange}
                  onPageChange={onPageChange}
                  perPageOptions={DEFAULT_PAGE_OPTIONS}
                /> */}
              </div>
            </div>
          </>
        ) : (
          <h5 className="text-center">no records found</h5>
        )}
      </Modal.Body>

      <Modal.Footer className="">
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DispatchListModal;
